<template>
  <v-card
    width="400"
    outlined
    tile
  >
    <input
      v-show="false"
      id="file_container"
      ref="fileInput"
      type="file"
      :accept="accept"
      @input="onFilePicked"
    >

    <v-container
      fill-height
      fluid
      style="cursor:pointer"
      @click="onPickFile"
    >
      <v-layout
        v-if="fileURL"
        align-center
        justify-space-around
        @click="onPickFile"
      >
        <v-flex
          xs12
          text-xs-center
        >
          <v-icon
            size="100"
            color="grey lighten-3"
          >
            mdi-folder-plus
          </v-icon>
          <br>
          <div class="subheading">
            {{ fileName }}
          </div>
        </v-flex>
      </v-layout>
      <v-layout
        v-else
        align-center
        justify-space-around
      >
        <v-icon
          size="100"
          color="grey lighten-3"
        >
          mdi-folder-plus
        </v-icon>
      </v-layout>
    </v-container>

    <v-divider />
    <v-card-actions class="ma-2">
      <v-spacer />
      <v-btn
        v-if="fileURL"
        id="image_remove"
        text
        color="error"
        @click="removeFile"
      >
        <v-icon>mdi-folder-remove</v-icon>
        {{ removeLabel }}
      </v-btn>
      <v-btn
        id="image_ok"
        text
        color="success"
        dark
        @click="onPickFile"
      >
        <v-icon>mdi-attachment</v-icon>
        {{ selectLabel }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
	name: "FileContainer",
	props: {
		value: {
			type: String,
			default: ""
		},
		selectLabel: {
			type: String,
			default: "Select"
		},
		removeLabel: {
			type: String,
			default: "Remove"
		},
		maxSize: {
			type: Number,
			default: 0
		},
		icon: {
			type: String,
			default: "mdi-folder"
		},
		clear: Boolean
	},
	data() {
		return {
			fileURL: "",
			fileName: ""
		};
	},
	methods: {
		onPickFile() {
			this.$refs.fileInput.click();
		},
		onFilePicked(event) {
			this.fileName = "";
			const files = event.target.files || event.dataTransfer.files;
			if (files && files[0]) {
				let filename = files[0].name;

				if (this.maxSize && files[0].size > this.maxSize) {
					let size = this.maxSize / 1024;
					this.$emit(
						"error",
						"Image size should not be more than " + size + " kb"
					);
					return;
				}

				const fileReader = new FileReader();
				fileReader.addEventListener("load", () => {
					this.fileURL = fileReader.result;
				});

				fileReader.readAsDataURL(files[0]);

				this.$emit("input", files[0]);
				this.fileName = filename;
			}
		},
		removeFile() {
			//clearing the selected file
			this.fileURL = "";
			this.fileName = "";

			//to enable uploading the same file back to back
			const input = this.$refs.fileInput;
			input.type = "text";
			input.type = "file";
      this.$emit("remove");
		},
		clearFile() {
			this.removeFile();
		}
	}
};
</script>